export const CartOffersTabNameEnum = Object.freeze({
    OFFERS: 'offers',
    OFFERS_COUPON_CODES: 'offersCouponCodes',
});
